"use client";

import { useSectionReveal } from "./useSectionReveal";

const STEPS = [
  {
    number: "01",
    title: "Pick Your Design",
    desc: "Browse our curated collection. Each template is handcrafted with cultural authenticity and premium animations.",
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="7" height="7" rx="1" />
        <rect x="14" y="3" width="7" height="7" rx="1" />
        <rect x="3" y="14" width="7" height="7" rx="1" />
        <path d="M14 14h7v7h-7z" strokeDasharray="2 2" />
      </svg>
    ),
  },
  {
    number: "02",
    title: "Share Your Story",
    desc: "Send us your details via WhatsApp — names, dates, venues, and photos. We handle all the customization.",
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" />
        <path d="M8 9h8M8 13h4" />
      </svg>
    ),
  },
  {
    number: "03",
    title: "Share & Celebrate",
    desc: "Get your unique link in 1-2 days. Share on WhatsApp, track RSVPs live, and enjoy your special day.",
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="18" cy="5" r="3" />
        <circle cx="6" cy="12" r="3" />
        <circle cx="18" cy="19" r="3" />
        <path d="M8.59 13.51l6.83 3.98M15.41 6.51l-6.82 3.98" />
      </svg>
    ),
  },
];

export default function HowItWorks() {
  const sectionRef = useSectionReveal<HTMLElement>();

  return (
    <section className="iv-how" id="how-it-works" ref={sectionRef}>
      <div className="iv-how__inner">
        <div className="iv-how__header">
          <h2 className="iv-how__title iv-font-display">
            Three Steps to Your
            <span className="iv-how__title-accent"> Perfect Invitation</span>
          </h2>
          <p className="iv-how__subtitle">
            We handle the design and tech. You focus on your celebration.
          </p>
        </div>

        <div className="iv-how__timeline">
          {/* Connecting line - desktop only */}
          <div className="iv-how__line">
            <div className="iv-how__line-fill" />
          </div>

          <div className="iv-how__steps">
            {STEPS.map((step, index) => (
              <div key={step.number} className="iv-how__step">
                <div className="iv-how__step-marker">
                  <span className="iv-how__step-number">{step.number}</span>
                </div>
                <div className="iv-how__step-content">
                  <div className="iv-how__step-icon">{step.icon}</div>
                  <h3 className="iv-how__step-title">{step.title}</h3>
                  <p className="iv-how__step-desc">{step.desc}</p>
                </div>
                {index < STEPS.length - 1 && (
                  <div className="iv-how__step-arrow">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M5 12h14M12 5l7 7-7 7" />
                    </svg>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="iv-how__cta">
          <a href="#templates" className="iv-how__cta-link">
            Browse Templates
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M3 8h10M9 4l4 4-4 4" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
}
